import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
const names = ['Lucía M.', 'Tomás F.', 'Julieta R.', 'Facundo G.', 'Micaela S.', 'Agustín P.', 'Carolina L.', 'Ignacio D.'];
const cities = ['Rosario', 'Córdoba', 'CABA', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Neuquén'];
export function Popup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  const timersRef = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    const showRandomBuyer = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = Math.floor(Math.random() * (40000 - 25000 + 1) + 25000);
        const nextTimer = setTimeout(showRandomBuyer, nextDelay);
        timersRef.current.push(nextTimer);
      }, 5000);
      timersRef.current.push(hideTimer);
    };
    const initialTimer = setTimeout(showRandomBuyer, 8000);
    timersRef.current.push(initialTimer);
    return () => {
      timersRef.current.forEach(t => clearTimeout(t));
      timersRef.current = [];
    };
  }, []);
  return <AnimatePresence data-id="element-134">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-50 bg-white border border-slate-200 shadow-xl rounded-lg p-3 pr-10 max-w-[300px] flex items-center gap-3" data-id="element-135">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-136">
            <ShoppingCart size={16} className="text-green-600" data-id="element-137" />
          </div>
          <div data-id="element-138">
            <p className="text-xs text-slate-500 mb-0.5" data-id="element-139">
              Alguien acaba de comprar
            </p>
            <p className="text-sm font-bold text-navy-900 leading-tight" data-id="element-140">
              {currentBuyer.name} de {currentBuyer.city} acaba de comprar el
              Manual
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-141">
            <X size={14} data-id="element-142" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}